import TUIChat from "./TUIChat.mjs";
import TUIConversation from "./TUIConversation.mjs";
import TUIGroup from "./TUIGroup.mjs";
import TUIContact from "./TUIContact.mjs";
import TUISearch from "./TUISearch.mjs";
import message from "./message.mjs";
import component from "./component.mjs";
import time from "./time.mjs";
import Words from "./words.mjs";
import Evaluate from "./evaluate.mjs";
import Emoji from "../../components/TUIChat/emoji-config/locales/en.mjs";
const messages = {
  en: {
    取消: "Cancel",
    发送: "Send",
    系统通知: "System notification",
    关闭: "Close",
    确定: "Save",
    开始时间: "Start Date",
    结束时间: "End Date",
    消息: "Messages",
    通讯录: "Contacts",
    欢迎使用腾讯云即时通信IM: "Welcome to Tencent Cloud Chat",
    TUIChat,
    TUIConversation,
    TUIGroup,
    TUIContact,
    message,
    component,
    time,
    Evaluate,
    Words,
    TUISearch,
    Emoji
  }
};
export {
  messages as default
};
